<div>
	<div class="ibox-title">
		<h5>{{ Title }} Blocked List Attempts</h5>
	</div>

	<div class="ibox-content">
		<!--Options-->
		<div class="ButtonGrid">
			<button
				[ngClass]="{
					btn: true,
					'btn-primary': OptionID != 0,
					'btn-warning': OptionID == 0
				}"
				(click)="SelectOption(0)"
			>
				Facility
			</button>

			<button
				[ngClass]="{
					btn: true,
					'btn-primary': OptionID != 1,
					'btn-warning': OptionID == 1
				}"
				(click)="SelectOption(1)"
			>
				District
			</button>
		</div>

		<!--Loading Overlay-->
		<div class="CenterDiv" *ngIf="StatsLoading == true">
			<p-progressSpinner></p-progressSpinner>
		</div>

		<!--Stats-->
		<div class="StatGrid" *ngIf="StatsLoading == false">
			<label>Attempts Today:</label>
			<p>{{ AttemptsToday }}</p>

			<label>Attempts Month-To-Date:</label>
			<p>{{ AttemptsMTD }}</p>

			<label>Attempts Year-To-Date:</label>
			<p>{{ AttemptsYTD }}</p>

			<label>All Attempts:</label>
			<p>{{ AttemptsAll }}</p>
		</div>

		<!--Table-->
		<div>
			<caass-ms-blocked-attempt-table [loading]="TableLoading" [lstVisitorPassDetail]="lstVisitorPassDetail"> </caass-ms-blocked-attempt-table>
		</div>
	</div>
</div>
